import { defineAsyncComponent } from 'vue'

export default {
  install(Vue, options) {
    if (FONTAWESOME.ENV !== 'production') {
      Vue.component('dashboard', defineAsyncComponent(() => import('./Dashboard')))
      Vue.component('subscription-dashboard', defineAsyncComponent(() => import('./SubscriptionDashboard')))
      Vue.component('permits-dashboard', defineAsyncComponent(() => import('./PermitsDashboard')))
      Vue.component('usage-dashboard', defineAsyncComponent(() => import('./UsageDashboard')))
    } else {
      Vue.component('dashboard', {})
      Vue.component('subscription-dashboard', {})
      Vue.component('permits-dashboard', {})
      Vue.component('usage-dashboard', {})
    }
  }
}
